import * as SSO_CONFIG from "./config";
import SSOServices from "./services";

export default {
  SSO_CONFIG,
  SSOServices,
};
